export enum Nav {
  'PAGE_TOP' = 'pageTop',
  'PAGE_BOTTOM' = 'pageBottom',
  'PREV_ROW' = -1,
  'NEXT_ROW' = 1,
  'NEXT_PAGE' = 'nextPage',
  'PREV_PAGE' = 'prevPage',
}
